import React from 'react';
import { connect } from 'react-redux';
import { openChat } from '~/src/store/actions/chat';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';
import { packageON, GA } from '~/src/api/channels';
import { selectHostname } from '~/src/store/selectors/domain';

import IconSuccess from '../success.svg';
import IconError from '../sad.svg';

import {
    PackageInfo,
    HDCount,
    Price,
    PriceCount,
    PriceUnit,
    Text,
    Title,
    StyledCheckbox,
    Controls,
    ControlsCenter,
    Button,
    ButtonBack,
    Icon,
    CenterBlock,
} from './styled';

const channelsText = declOfNum(['канал', 'канала', 'каналов']);
const pad = (n) => (`0${n}`).slice(-2);

class ConnectForm extends React.Component {
    state = {
        isSuccess: false,
        errorCode: '',
        autoDisable: false,
    }

    onCheckboxChange = () => {
        this.setState(({ autoDisable }) => ({
            autoDisable: !autoDisable,
        }));
    }

    sendOrder = async() => {
        const { data, auth: { clientPersonal, accessToken }, billingHost, onSuccess } = this.props;
        const { autoDisable } = this.state;
        const channel = data.channel;

        if (!channel) {
 return;
}

        const isBaseCost = (data.cost === channel.cost);
        const requestData = {
            billingHost: billingHost,
            agreement_id: clientPersonal.agreementId,
            access_token: accessToken,
            tr_id: data.terminalId,
            packet: channel.id,
        };

        if (!isBaseCost) {
            requestData.ra_id = channel.costRa.find(el => el.cost === data.cost).raId;

            if (channel.state.dateTo !== null) {
                const d = new Date(channel.state.dateTo * 1000);
                requestData.date_to = `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
            }

            requestData.close_packet = (autoDisable === true) ? 1 : 0;
        }

        GA({
            action: 'click on confirm',
            label: `${channel.name}, ${isBaseCost ? 'базовая цена' : `подписка на ${data.duration} мес`}`,
        });

        try {
            const result = await packageON(requestData);

            if (Number(result.status) !== 1) {
                this.setState({ isSuccess: false, errorCode: result.errorCode });

                GA({
                    action: 'error connect the channel',
                    label: `${channel.name}, ${isBaseCost ? 'базовая цена' : `подписка на ${data.duration} мес`}`,
                });
            } else {
                GA({
                    action: 'successful connect the channel',
                    label: `${channel.name}, ${isBaseCost ? 'базовая цена' : `подписка на ${data.duration} мес`}`,
                });

                onSuccess();
                this.setState({ isSuccess: true, errorCode: '' });
            }
        } catch (e) {
            GA({
                action: 'error connect the channel',
                label: `${channel.name}, ${isBaseCost ? 'базовая цена' : `подписка на ${data.duration} мес`}`,
            });

            this.setState({ isSuccess: false, errorCode: 'Error' });
        }
    }

    onSuccessClick = () => {
        const { onClose } = this.props;

        onClose();
    }

    onErrorClick = () => {
        this.props.onClose();
        this.props.openChat();
    }

    render() {
        const { onClose, data } = this.props;
        const { isSuccess, errorCode, autoDisable } = this.state;
        const channel = (data.channel) ? data.channel : {};
        const isBaseCost = (data.cost === channel.cost);
        const contentText = isBaseCost
            ? `Вы подключаете пакет каналов «${channel.name}» с абонентской платой ${data.cost} ₽/мес.`
            : `Вы подключаете пакет каналов «${channel.name}» на ${data.duration} мес. с абонентской платой ${data.cost}&nbsp;₽/мес. После окончания действия скидки, абонентская плата составит ${channel.cost}&nbsp;₽/мес.`;

        let content = (
            <React.Fragment>
                <PackageInfo>
                    <HDCount>{`${channel.channelsCount} ${channelsText(channel.channelsCount)} (${channel.channelsCountHd}HD)`}</HDCount>
                    <Price>
                        <PriceCount>{data.cost}</PriceCount>
                        <PriceUnit>₽/мес</PriceUnit>
                    </Price>
                </PackageInfo>
                <Text dangerouslySetInnerHTML={{ __html: contentText }} />
                {!isBaseCost && <StyledCheckbox checked={autoDisable} onChange={this.onCheckboxChange} name='autodisable'>Отключить пакет автоматически после окончания действия подписки</StyledCheckbox> }
                <Controls>
                    <Button onClick={this.sendOrder}>Подтвердить</Button>
                    <ButtonBack onClick={onClose}>Вернуться назад</ButtonBack>
                </Controls>
            </React.Fragment>
        );

        if (isSuccess) {
            const textSuccess = isBaseCost
            ? `Пакет каналов «${channel.name}» подключен с абонентской платой ${data.cost} ₽/мес.`
            : `Пакет каналов «${channel.name}» подключен на ${data.duration} мес. с абонентской платой ${data.cost}&nbsp;₽/мес. После окончания срока действия скидки, абонентская плата составит ${channel.cost}&nbsp;₽/мес.`;

            content = (
                <React.Fragment>
                    <Icon src={IconSuccess} alt='Success'/>
                    <CenterBlock>
                        <Title>Пакет каналов успешно подключен</Title>
                        <Text dangerouslySetInnerHTML={{ __html: textSuccess }} />
                    </CenterBlock>
                    <ControlsCenter>
                        <Button onClick={this.onSuccessClick}>Спасибо</Button>
                    </ControlsCenter>
                </React.Fragment>
            );
        } else if (errorCode !== '') {
            let errorText = 'Возникла ошибка при подключении пакета каналов. Напишите в чат техподдержки, мы поможем.';
            if (errorCode === 'INSUFFICIENT_DEBIT_BALANCE') {
 errorText = 'Недостаточно средств для подключения пакета каналов. Пожалуйста пополните счет.';
} else if (errorCode === 'PACKET_ALREADY_ACTIVE') {
 errorText = 'Пакет каналов уже подключен';
}

            content = (
                <React.Fragment>
                    <Icon src={IconError} alt='Error'/>
                    <CenterBlock>
                        <Title>Произошла ошибка ...</Title>
                        <Text>{errorText}</Text>
                    </CenterBlock>
                    <ControlsCenter>
                        <Button onClick={this.onErrorClick}>Написать в чат</Button>
                    </ControlsCenter>
                </React.Fragment>
            );
        }

        return content;
    }
}

const mapStateToProps = ({ city, auth }) => ({
    billingHost: selectHostname({ auth, city }),
    auth,
});

const mapDispatchToProps = (dispatch) => ({
    openChat: () => dispatch(openChat())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ConnectForm);
